import { render } from "./SeleccionRecepcionesPage.vue?vue&type=template&id=7fbff95f&scoped=true"
import script from "./SeleccionRecepcionesPage.vue?vue&type=script&lang=js"
export * from "./SeleccionRecepcionesPage.vue?vue&type=script&lang=js"

import "./SeleccionRecepcionesPage.vue?vue&type=style&index=0&id=7fbff95f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbff95f"]])

export default __exports__